<div class="flex flex-col items-center gap-6 md:flex-row md:items-start">
  <div class="flex w-full flex-col gap-4 md:w-2/3">
    <div
      class="rounded-2xl border p-6"
      [ngStyle]="{
        borderColor: corporateDesign.primaryBorderColor(),
        backgroundColor: corporateDesign.surface1(),
        color: corporateDesign.isDarkModeActive()
          ? corporateDesign.corporateDesign().primaryDarkFontColor
          : corporateDesign.corporateDesign().colorAdmixtures
              .standard_text_high,
      }">
      <h2 class="my-2 text-2xl font-bold">
        {{
          textStore.texts()
            | filterTexts
              : ERelationType.thankYou
              : EEntityType.onDemandTicketConfiguration
            | language
        }}
      </h2>

      <aw-on-demand-journey-timeline />

      <div
        class="my-5 rounded-2xl border p-6"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
          backgroundColor: corporateDesign.isDarkModeActive()
            ? corporateDesign.corporateDesign().colorAdmixtures.dark_surface_02
            : corporateDesign.surface1(),
          color: corporateDesign.isDarkModeActive()
            ? corporateDesign.corporateDesign().primaryDarkFontColor
            : corporateDesign.corporateDesign().colorAdmixtures
                .standard_text_high,
        }">
        <h3 class="mb-4 text-xl font-bold">
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.paymentAddress
                : EEntityType.onDemandTicketConfiguration
              | language
          }}
        </h3>
        @if (userStore.user(); as user) {
          <p class="text-base font-medium">
            {{ salutationStore.getTexts(user.salutation) | language }}
            {{ user.firstName }}
            {{ user.lastName }}
          </p>
          <p class="text-sm opacity-60">
            {{ user.address.street }} {{ user.address.houseNumber }}
          </p>
          <p class="text-sm opacity-60">
            {{ user.address.postCode }} {{ user.address.city }}
          </p>
          <p class="text-sm opacity-60">{{ user.address.country }}</p>
        }
      </div>
    </div>
  </div>

  <aw-on-demand-ticket-configuration-summary />
</div>
